import { createContext } from 'react';
import { PluginContextType } from './types';

export const PluginContext = createContext<PluginContextType | null>(null);
